export const API_URL = process.env.REACT_APP_API_URL || "http://0.0.0.0:3000/local/bundles/";
export const TX_PER_PAGE = 16;